/**
 * OrderConfirmationPage
 * @module pages/OrderConfirmationPage
 */

import React, { useEffect } from 'react';
import Layout from 'components/ui/Layout';
//
import ContentArea from 'components/framework/ContentArea';
import RichText from 'components/ui/RichText';
import CustomExternalScript from 'components/framework/CustomExternalScript';
import Icon from 'components/ui/Icon';
import { OrderConfirmationPageModel } from 'types/page-types';
import { LinkModel } from 'types/common';
import Button from 'components/ui/Button';

const OrderConfirmationPage = ({
	heading,
	text,
	punchoutHtml,
	message,
	deliveryNoteButton,
	contentArea,
	isInEditMode,
	order,
	orderId,
	exportLinks,
	framework,
}: OrderConfirmationPageModel) => {
	useEffect(() => {
		let items: any = [];

		order.articles?.map((art: any) => {
			return items.push({
				item_name: art.itemName,
				item_id: art.itemCode,
				price: art.prices.grossPriceFormatted,
				item_variant: art.attributeName,
				quantity: art.quantity,
			});
		});

		if (window.dataLayer) {
			window.dataLayer.push({
				event: 'purchase',
				domain: framework?.header.activeMarket,
				ecommerce: {
					currency: order.currency,
					value: order.total,
					tax: order.tax,
					shipping: order.shipping,
					transaction_id: order.trackingId,
					items: items,
				},
			});
		}
		//eslint-disable-next-line
	}, []);

	return (
		<main id="main-content">
			<Layout>
				<div className="md:w-160 max-w-full">
					{heading && (
						<div className="flex items-center justify-between">
							{heading && (
								<h1 className="font-heading mb-6 mt-10 font-bold text-h2 md:text-h1 text-blue">
									{heading}
									{orderId && (
										<span style={{ display: 'block' }}>{orderId}</span>
									)}
								</h1>
							)}

							<div>
								<Icon icon="check" color="green" className="w-32 h-32" />
							</div>
						</div>
					)}

					{text && (
						<RichText
							name="text"
							size="large"
							text={text}
							className="m-0"
							isInEditMode={isInEditMode}
						/>
					)}

					{deliveryNoteButton?.text && deliveryNoteButton?.link && (
						<Button
							type="link"
							buttonColor="grey"
							url={deliveryNoteButton.link}
							target="_blank"
							className="mb-8"
						>
							<div className="flex justify-center  items-center">
								{deliveryNoteButton?.text} <Icon icon={'file'} size={2} />
							</div>
						</Button>
					)}

					{exportLinks && exportLinks.length > 0 && (
						<div className="flex justify-start items-center gap-4">
							{exportLinks?.map((exportLink: LinkModel, index: number) => {
								return (
									<a
										href={exportLink?.link}
										download
										className="text-p text-blue hover:underline"
										key={index}
									>
										<Icon
											className="mr-2"
											icon="download"
											size={2}
											aria-hidden="true"
										/>
										{exportLink?.text}
									</a>
								);
							})}
						</div>
					)}

					{punchoutHtml && (
						<RichText
							name="text"
							size="large"
							text={punchoutHtml}
							className="m-0"
							isInEditMode={isInEditMode}
						/>
					)}

					<CustomExternalScript />
					{message && <p className="text-red">{message}</p>}
				</div>
			</Layout>
			{contentArea && (
				<div className="mt-10">
					<ContentArea contentArea={contentArea} />
				</div>
			)}
		</main>
	);
};

export default OrderConfirmationPage;
